import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/core';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi } from '@digibricks/plugin-axios';
import { CreateSubmissionResponse, PracticeSubmissionResult } from '../../../core';
export var PRACTICE_SUBMISSION_API = 'PRACTICE_SUBMISSION_API';
export var PracticeSubmissionApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(PracticeSubmissionApi, _AxiosApi);

  var _super = _createSuper(PracticeSubmissionApi);

  function PracticeSubmissionApi(axiosInstance) {
    var _this;

    _classCallCheck(this, PracticeSubmissionApi);

    _this = _super.call(this, 'practice-submissions', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(PracticeSubmissionApi, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.post(this.url, input);

              case 3:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;
                return _context.abrupt("return", CreateSubmissionResponse.create(parsedResponseBody.data));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "pause",
    value: function () {
      var _pause = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(useCaseInput) {
        var id, _input, url;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                id = useCaseInput.id, _input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(id, "/pause");
                _context2.next = 5;
                return this.axios.put(url, _input);

              case 5:
                return _context2.abrupt("return", Result.ok());

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function pause(_x2) {
        return _pause.apply(this, arguments);
      }

      return pause;
    }()
  }, {
    key: "resume",
    value: function () {
      var _resume = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(useCaseInput) {
        var id, _input2, url;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                id = useCaseInput.id, _input2 = useCaseInput.input;
                url = "".concat(this.url, "/").concat(id, "/resume");
                _context3.next = 5;
                return this.axios.put(url, _input2);

              case 5:
                return _context3.abrupt("return", Result.ok());

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function resume(_x3) {
        return _resume.apply(this, arguments);
      }

      return resume;
    }()
  }, {
    key: "submit",
    value: function () {
      var _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(useCaseInput) {
        var id, _input3, url, jsonResponse, parsedResponseBody, response, resultOrError;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                id = useCaseInput.id, _input3 = useCaseInput.input;
                url = "".concat(this.url, "/").concat(id, "/submit");
                _context4.next = 5;
                return this.axios.put(url, _input3);

              case 5:
                jsonResponse = _context4.sent;
                parsedResponseBody = jsonResponse.data;
                response = parsedResponseBody.data;
                resultOrError = PracticeSubmissionResult.fromJson(response.result);

                if (!resultOrError.isFailure) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return", Result.fail(resultOrError.error));

              case 11:
                return _context4.abrupt("return", Result.ok({
                  id: response.id,
                  attendeeId: response.attendeeId,
                  submitTime: response.submitTime,
                  result: resultOrError.getValue()
                }));

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t0));

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 14]]);
      }));

      function submit(_x4) {
        return _submit.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(useCaseInput) {
        var id, _input4, url;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                id = useCaseInput.id, _input4 = useCaseInput.input;
                url = "".concat(this.url, "/").concat(id);
                _context5.next = 5;
                return this.axios.patch(url, {
                  audioPlayStats: {
                    audioFileId: _input4.audioPlayStats.audioFileId,
                    scope: _input4.audioPlayStats.scope
                  }
                });

              case 5:
                return _context5.abrupt("return", Result.ok());

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", ErrorResultHandler(_context5.t0));

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 8]]);
      }));

      function update(_x5) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }]);

  return PracticeSubmissionApi;
}(AxiosApi);